import React from 'react';
import styles from './Spinner.module.scss';

const Spinner = () => {
  return (
    <div className={styles.ldsCss} data-testid="spinner">
      <div className={styles.ldsDoubleRing}>
        <div></div>
        <div></div>
      </div>
    </div>
  );
};

export default Spinner;
